import styled from 'styled-components';
import  ScrollbarContainer from '../scrollBarContainer/scrollBarContainer';

//@ts-ignore
export const WrapperList = styled(ScrollbarContainer)`
  height: 100%;
  overflow-y: scroll;
  margin-bottom: 20px;
`;
